import React, { useState, useEffect } from "react";
import axios from "axios";
import ReusableTabs from "../../pages/ReusableTabs";
import ReceivingModules from "./receivingModules";

const ReceivingTabsComponent = () => {
  const [tabs, setTabs] = useState([]);
  const [selectedTab, setSelectedTab] = useState(0);
  const baseURL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchSuppliers = async () => {
      try {
        const selectedProject = localStorage.getItem("selectedProject");
        const response = await axios.post(`${baseURL}get_supplier_names`, {
          projectId: selectedProject,
        });
        const data = response.data;
        const supplierTabs = data.map(supplier => ({
          label: supplier.name,
          component: <ReceivingModules supplierName={supplier.name} />
        }));
        setTabs(supplierTabs);

        // Load selected tab from sessionStorage or set first tab as default
        const storedSupplier = sessionStorage.getItem("selectedSupplierTab");
        if (storedSupplier) {
          const storedTabIndex = supplierTabs.findIndex(tab => tab.label === storedSupplier);
          if (storedTabIndex !== -1) {
            setSelectedTab(storedTabIndex);
          } else if (supplierTabs.length > 0) {
            // Stored supplier not found, default to first tab
            setSelectedTab(0);
            sessionStorage.setItem("selectedSupplierTab", supplierTabs[0].label);
          }
        } else if (supplierTabs.length > 0) {
          // No stored supplier, set first tab and store its supplierName
          setSelectedTab(0);
          sessionStorage.setItem("selectedSupplierTab", supplierTabs[0].label);
        }
      } catch (error) {
        console.error('Error fetching supplier names:', error);
      }
    };

    fetchSuppliers();
  }, []);

  // Handle tab change and update sessionStorage
  const handleTabChange = (index) => {
    setSelectedTab(index);
    if (tabs[index]?.label) {
      sessionStorage.setItem("selectedSupplierTab", tabs[index].label);
    }
  };

  return (
    <ReusableTabs
      tabs={tabs}
      defaultTab={selectedTab}
      onTabChange={handleTabChange}
      panelStyles={{ padding: '16px' }}
    />
  );
};

export default ReceivingTabsComponent;